"use strict";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSimpleCodeEditor = _interopRequireDefault(require("react-simple-code-editor"));

var _prismCore = require("prismjs/components/prism-core");

require("prismjs/components/prism-clike");

require("prismjs/components/prism-json");

require("prismjs/components/prism-sql");

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CodeEditor = function CodeEditor(_ref) {
  var id = _ref.id,
      value = _ref.value,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      onChange = _ref.onChange,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["id", "value", "disabled", "invalid", "onChange", "type"]);

  return _react["default"].createElement(_style.StyledField, {
    disabled: disabled,
    invalid: invalid
  }, _react["default"].createElement(_style.EditorStyles, null, _react["default"].createElement(_reactSimpleCodeEditor["default"], _extends({
    textareaId: id,
    value: value,
    onValueChange: function onValueChange(code) {
      return onChange(code);
    },
    highlight: function highlight(code) {
      return (0, _prismCore.highlight)(code, _prismCore.languages[type]);
    },
    padding: 10,
    style: {
      fontFamily: '"Fira code", "Fira Mono", monospace',
      fontSize: 12
    }
  }, props))));
};

CodeEditor.propTypes = {
  id: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  invalid: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
CodeEditor.defaultProps = {
  disabled: false,
  type: 'json',
  invalid: false,
  onChange: function onChange() {}
};
var _default = CodeEditor;
exports["default"] = _default;